import React, { useState } from "react"
import { twClassNames } from "../helpers/classNames"

interface DragZoneProps extends Omit<React.HTMLAttributes<HTMLDivElement>, "onDrop"> {
  onDrop: (file: File) => void
  className?: string
}

const DragZone = ({ onDrop, className, ...props }: DragZoneProps) => {
  const [active, setDragActive] = useState(false)

  const handleEnter = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setDragActive(true)
  }

  const handleLeave = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setDragActive(false)
  }

  const handleOver = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
  }

  const handleDrop = (e: React.DragEvent<HTMLDivElement>) => {
    e.preventDefault()
    e.stopPropagation()
    setDragActive(false)
    if (e.dataTransfer.files.length > 0) {
      onDrop(e.dataTransfer.files[0])
    }
  }

  return (
    <div
      onDragEnter={handleEnter}
      onDragLeave={handleLeave}
      onDragOver={handleOver}
      onDrop={handleDrop}
      className={twClassNames(active && "tw-border-primary", className, "[&>*]:tw-pointer-events-none")}
      {...props}>
      {props.children}
    </div>
  )
}

export default DragZone
